import { useState, useEffect, useRef } from 'react';

/**
 * PEHLI BAAR game open hote hi 5-sec fixed loader (sirf ek baar, poore session mein).
 * Uske baad: processing loader SIRF tab dikhega jab bettingClosed=true hai
 * (matlab animation/reveal phase chal raha hai) but card data abhi tak
 * nahi aaya — matlab stuck state. Betting-open phase mein kabhi nahi dikhega.
 */
const useGameScreenLoader = (roundId, bettingClosed, hasData, fixedDuration = 5000) => {
    const [gameScreenLoader, setGameScreenLoader] = useState(false); // sirf first-mount
    const [processingLoader, setProcessingLoader] = useState(false); // stuck-during-reveal
    const fixedTimeoutRef = useRef(null);
    const isFirstMountRef = useRef(true);

    // Fixed 5-sec loader — SIRF PEHLI BAAR
    useEffect(() => {
        if (isFirstMountRef.current) {
            isFirstMountRef.current = false;
            setGameScreenLoader(true);
            fixedTimeoutRef.current = setTimeout(() => {
                setGameScreenLoader(false);
            }, fixedDuration);
        }
        return () => clearTimeout(fixedTimeoutRef.current);
    }, []);

    // Processing loader — SIRF jab bettingClosed hai (reveal phase) AND data missing hai
    useEffect(() => {
        const shouldWait = bettingClosed && !hasData;

        if (!gameScreenLoader && shouldWait) {
            setProcessingLoader(true);
        } else {
            setProcessingLoader(false);
        }
    }, [gameScreenLoader, bettingClosed, hasData]);

    return { gameScreenLoader, processingLoader };
};

export default useGameScreenLoader;